import { createContext } from 'react'

export const BranchComparisonMode = createContext(true)